import React, { useRef } from 'react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { AgGridReact } from 'ag-grid-react';
import { columnDefs } from './columnDefs';
import clearingAccountsOpts from './options';
import useContext from './useClearingAccountsContext';
import useOnCellClick from './useOnCellClick';
import ClearingMemberAccountsContainer from 'containers/ClearingMemberAccounts/ClearingMemberAccountsContainer';
import useDatasource from './useClearingAccountsDatasource';

export const CLEARING_ACCOUNTS_GRID_NAME = 'clearingAccountsGrid';
const CLEARING_ACCOUNTS_GRID_VERSION = 1;

const ClearingAccountsGrid = () => {
  const gridRef = useRef<AgGridReact>(null);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName: CLEARING_ACCOUNTS_GRID_NAME,
    version: CLEARING_ACCOUNTS_GRID_VERSION,
  });

  const onCellClicked = useOnCellClick();
  const context = useContext();
  const datasource = useDatasource();

  return (
    <div className="ag-theme-quartz">
      {gridVisible ? (
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          gridOptions={clearingAccountsOpts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          rowModelType="serverSide"
          serverSideDatasource={datasource}
          context={context}
          onCellClicked={onCellClicked}
        />
      ) : null}
    </div>
  );
};

export const ClearingAccountsView = () => {
  return (
    <ClearingMemberAccountsContainer
      gridOpts={{
        gridName: CLEARING_ACCOUNTS_GRID_NAME,
        GridComponent: ClearingAccountsGrid,
      }}
    />
  );
};

export default ClearingAccountsGrid;
